import React from "react";
import { inject, observer } from "mobx-react";
import { withStyles } from "@material-ui/core/styles";

import {
  Route,
  Switch,
  withRouter,
} from "react-router-dom";

import {
  Box,
  CircularProgress,
  Container,
  CssBaseline,
} from "@material-ui/core";

import Sidebar from "./components/Sidebar";

import Login from "./components/Login";

import SensorInfo from "./SensorInfo";
import SensorList from "./SensorList";

import SensorGroupInfo from "./SensorGroupInfo";
import SensorGroupList from "./SensorGroupList";

import RoomEdit from "./components/RoomEdit";

import Overview from "./components/Overview";

import SnackbarNotifications from "./components/SnackbarNotifications";
import Settings from "./components/Settings";
import ViewSelector from "./components/ViewSelector";

const drawerWidth = "15rem";

const styles = theme => ({
  Root: {
    height: "100vh",
    width: "100%"
  },

  Main: {
    width: "100%",
    height: "100%",
    display: "flex",
    padding: "0rem",
    margin: "0rem",
    maxWidth: "none",
    flexGrow: 1,
    overflow: "auto"
  },

  SidebarContainer: {
    width: drawerWidth,
  },

  ProgressContainer: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },

  ContentContainer: {
    overflow: "auto",
    height: "100%",
    width: "100%",
    backgroundColor: "#f5f5f5",
    padding: theme.spacing(3, 3),
  },
});

class App extends React.Component {
  render() {
    const classes = this.props.classes;
    
    if (this.props.bootstrapping) {
      return (
        <Box className={classes.ProgressContainer}>
          <CircularProgress className={classes.Progress} />
        </Box>
      );
    }

    if (!this.props.user) {
      return(<>
        <SnackbarNotifications />
        <Login />
      </>);
    }

    const content = (
      <Box className={classes.ContentContainer}>
        <Switch>
          <Route path="/overview"><Overview /></Route>
          <Route path="/varieties/:variety_id"><Overview /></Route>
          <Route
            path="/devices/:id"
            render={props => <SensorInfo id={props.match.params.id} key={(this.props.user || {}).id} />}
          />
          <Route
            path="/devices"
            render={props => <SensorList {...props} key={(this.props.user || {}).id} />}
          />
          <Route
            path="/sensors/:id"
            render={props => <SensorGroupInfo id={props.match.params.id} key={(this.props.user || {}).id} />}
          />
          <Route
            path="/sensors"
            render={props => <SensorGroupList {...props} key={(this.props.user || {}).id} />}
          />
          <Route
            path="/rooms/:id"
            render={props => <RoomEdit id={props.match.params.id} key={(this.props.user || {}).id} />}
          />
          <Route path="/settings"><Settings /></Route>
          <Route path="/view-selector"><ViewSelector /></Route>
          <Route path="/"><Overview /></Route>
        </Switch>
      </Box>
    );

    return (
      <Box className={classes.Root}>
        <CssBaseline />
        <Container component="main" className={classes.Main}>
          <SnackbarNotifications />
          <Box className={classes.SidebarContainer}>
            <Sidebar />
          </Box>
          { content }
        </Container>
      </Box>
    );
  }
}

export default withRouter(withStyles(styles)(
  inject(stores => ({
    bootstrapping: stores.rootStore.authStore.bootstrapping,
    user: stores.rootStore.authStore.user,
  }))(observer(App))
));
